import { Injectable } from '@angular/core';

// campfire
import { UserService } from '@campfire-nx/api';
import { LoggerService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private userData?: any;

  constructor(
    private userService: UserService,
    private loggerService: LoggerService
  ) { }

  getUserData() {
    // Return cached userData if available
    if (this.userData) {
      return new Promise((resolve, reject) => {
        resolve(this.userData);
      });
    } else {
      // Call API if userData is not set yet
      return this.userService
        .getUserData()
        .then((response: any) => {
          this.userData = response;

          return this.userData;
        })
        .catch((err) => {
          this.loggerService.error('UserDataService', 'getUserData', { error: err });
        });
    }
  }

  getLatestUserData() {
    return this.userService.getUserData()
      .then((response: any) => {
        this.userData = response;

        return this.userData;
      })
      .catch((err) => {
        this.loggerService.error('UserDataService', 'getLatestUserData', { error: err });
      });
  }
}
